{
	"asset":{
		"generator":"Khronos glTF Blender I/O v4.1.63",
		"version":"2.0"
	},
	"scene":0,
	"scenes":[
		{
			"name":"Scene",
			"nodes":[
				0,
				1,
				2,
				3,
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12
			]
		}
	],
	"nodes":[
		{
			"mesh":0,
			"name":"head.026",
			"scale":[
				0.8984315395355225,
				0.9587109684944153,
				0.9587109684944153
			],
			"translation":[
				0,
				3.987575054168701,
				0
			]
		},
		{
			"mesh":1,
			"name":"Cube.111",
			"rotation":[
				-1,
				0,
				0,
				4.371139183945161e-08
			],
			"scale":[
				-0.045032501220703125,
				-0.045032501220703125,
				-0.045032501220703125
			],
			"translation":[
				-0.8820033073425293,
				3.9419164657592773,
				0
			]
		},
		{
			"mesh":2,
			"name":"Cube.112",
			"rotation":[
				0,
				0,
				-0.18223552405834198,
				0.9832549095153809
			],
			"scale":[
				-0.045032501220703125,
				-0.045032501220703125,
				-0.045032501220703125
			],
			"translation":[
				-0.7015438675880432,
				4.559999942779541,
				0.3400000035762787
			]
		},
		{
			"mesh":3,
			"name":"Cube.113",
			"rotation":[
				0,
				0,
				-0.18223552405834198,
				0.9832549095153809
			],
			"scale":[
				-0.045032501220703125,
				-0.045032501220703125,
				-0.045032501220703125
			],
			"translation":[
				-0.7015438675880432,
				4.559999942779541,
				-0.3400000035762787
			]
		},
		{
			"mesh":4,
			"name":"Cube.114",
			"rotation":[
				0,
				0,
				-0.18234197795391083,
				0.9832351803779602
			],
			"scale":[
				-0.608928382396698,
				-0.608928382396698,
				-0.6089284420013428
			],
			"translation":[
				-0.8017759919166565,
				4.231659889221191,
				-0.34039801359176636
			]
		},
		{
			"mesh":5,
			"name":"Cube.115",
			"rotation":[
				0,
				0,
				-0.18234197795391083,
				0.9832351803779602
			],
			"scale":[
				-0.608928382396698,
				-0.608928382396698,
				-0.6089284420013428
			],
			"translation":[
				-0.8017759919166565,
				4.231659889221191,
				0.34039801359176636
			]
		},
		{
			"mesh":6,
			"name":"body.026",
			"scale":[
				0.937124490737915,
				1,
				1
			],
			"translation":[
				0,
				2.146585464477539,
				0
			]
		},
		{
			"mesh":7,
			"name":"foot left.027",
			"rotation":[
				0,
				0,
				-0.14311254024505615,
				0.9897063970565796
			],
			"scale":[
				0.18387234210968018,
				0.18387234210968018,
				0.18387234210968018
			],
			"translation":[
				-0.8038689494132996,
				0.1720389872789383,
				-0.4628182053565979
			]
		},
		{
			"mesh":8,
			"name":"foot right.027",
			"rotation":[
				0,
				0,
				0.14499302208423615,
				0.9894327521324158
			],
			"scale":[
				0.18387234210968018,
				0.18387234210968018,
				0.18387234210968018
			],
			"translation":[
				0.8274589776992798,
				0.20774923264980316,
				0.5771837830543518
			]
		},
		{
			"mesh":9,
			"name":"hand left.027",
			"rotation":[
				0.19143562018871307,
				0.03714977204799652,
				0.18961648643016815,
				0.9622982144355774
			],
			"scale":[
				0.30448251962661743,
				0.5152471661567688,
				0.5152481198310852
			],
			"translation":[
				0.368542343378067,
				2.2653894424438477,
				-1.5375065803527832
			]
		},
		{
			"mesh":10,
			"name":"hand right.027",
			"rotation":[
				0.5078092813491821,
				-0.10572641342878342,
				-0.17530430853366852,
				0.8367915153503418
			],
			"scale":[
				0.30448251962661743,
				0.5152471661567688,
				0.5152481198310852
			],
			"translation":[
				-0.5130943059921265,
				2.2653884887695312,
				1.5375065803527832
			]
		},
		{
			"mesh":11,
			"name":"leg left.027",
			"rotation":[
				0,
				0,
				-0.15854127705097198,
				0.9873523712158203
			],
			"scale":[
				0.08088663220405579,
				0.9437786936759949,
				0.0863136574625969
			],
			"translation":[
				-0.4795011281967163,
				0.8947574496269226,
				-0.46000000834465027
			]
		},
		{
			"mesh":12,
			"name":"leg right.027",
			"rotation":[
				0,
				0,
				0.21867312490940094,
				0.9757981896400452
			],
			"scale":[
				0.08088663965463638,
				0.9437786340713501,
				0.0863136574625969
			],
			"translation":[
				0.49766865372657776,
				0.9765802025794983,
				0.46000000834465027
			]
		}
	],
	"materials":[
		{
			"doubleSided":true,
			"name":"Material.046",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.8079805374145508,
					0.7261698842048645,
					0,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.045",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.0036458494141697884,
					0.043452225625514984,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.044",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.0036458494141697884,
					0.043452225625514984,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.047",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0,
					0.0036458494141697884,
					0.043452225625514984,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		},
		{
			"doubleSided":true,
			"name":"Material.022",
			"pbrMetallicRoughness":{
				"baseColorFactor":[
					0.8079805374145508,
					0.7261698842048645,
					0,
					1
				],
				"metallicFactor":0,
				"roughnessFactor":0.5
			}
		}
	],
	"meshes":[
		{
			"name":"Cube.362",
			"primitives":[
				{
					"attributes":{
						"POSITION":0,
						"NORMAL":1,
						"TEXCOORD_0":2
					},
					"indices":3,
					"material":0
				}
			]
		},
		{
			"name":"Cube.358",
			"primitives":[
				{
					"attributes":{
						"POSITION":4,
						"NORMAL":5,
						"TEXCOORD_0":6
					},
					"indices":7,
					"material":1
				}
			]
		},
		{
			"name":"Cube.359",
			"primitives":[
				{
					"attributes":{
						"POSITION":8,
						"NORMAL":9,
						"TEXCOORD_0":10
					},
					"indices":7,
					"material":2
				}
			]
		},
		{
			"name":"Cube.360",
			"primitives":[
				{
					"attributes":{
						"POSITION":11,
						"NORMAL":12,
						"TEXCOORD_0":13
					},
					"indices":7,
					"material":3
				}
			]
		},
		{
			"name":"Cube.361",
			"primitives":[
				{
					"attributes":{
						"POSITION":14,
						"NORMAL":15,
						"TEXCOORD_0":16
					},
					"indices":17,
					"material":3
				}
			]
		},
		{
			"name":"Cube.364",
			"primitives":[
				{
					"attributes":{
						"POSITION":18,
						"NORMAL":19,
						"TEXCOORD_0":20
					},
					"indices":17,
					"material":3
				}
			]
		},
		{
			"name":"Cube.363",
			"primitives":[
				{
					"attributes":{
						"POSITION":21,
						"NORMAL":22,
						"TEXCOORD_0":23
					},
					"indices":24,
					"material":0
				}
			]
		},
		{
			"name":"Cube.292",
			"primitives":[
				{
					"attributes":{
						"POSITION":25,
						"NORMAL":26,
						"TEXCOORD_0":27
					},
					"indices":28,
					"material":4
				}
			]
		},
		{
			"name":"Cube.293",
			"primitives":[
				{
					"attributes":{
						"POSITION":29,
						"NORMAL":30,
						"TEXCOORD_0":31
					},
					"indices":28,
					"material":4
				}
			]
		},
		{
			"name":"Cube.294",
			"primitives":[
				{
					"attributes":{
						"POSITION":32,
						"NORMAL":33,
						"TEXCOORD_0":34
					},
					"indices":35,
					"material":4
				}
			]
		},
		{
			"name":"Cube.295",
			"primitives":[
				{
					"attributes":{
						"POSITION":36,
						"NORMAL":37,
						"TEXCOORD_0":38
					},
					"indices":39,
					"material":4
				}
			]
		},
		{
			"name":"Cylinder.075",
			"primitives":[
				{
					"attributes":{
						"POSITION":40,
						"NORMAL":41,
						"TEXCOORD_0":42
					},
					"indices":43,
					"material":4
				}
			]
		},
		{
			"name":"Cylinder.076",
			"primitives":[
				{
					"attributes":{
						"POSITION":44,
						"NORMAL":45,
						"TEXCOORD_0":46
					},
					"indices":43,
					"material":4
				}
			]
		}
	],
	"accessors":[
		{
			"bufferView":0,
			"componentType":5126,
			"count":368,
			"max":[
				0.9663493633270264,
				0.7516860961914062,
				0.9663493633270264
			],
			"min":[
				-0.9663493633270264,
				-0.7516862154006958,
				-0.9663493633270264
			],
			"type":"VEC3"
		},
		{
			"bufferView":1,
			"componentType":5126,
			"count":368,
			"type":"VEC3"
		},
		{
			"bufferView":2,
			"componentType":5126,
			"count":368,
			"type":"VEC2"
		},
		{
			"bufferView":3,
			"componentType":5123,
			"count":516,
			"type":"SCALAR"
		},
		{
			"bufferView":4,
			"componentType":5126,
			"count":112,
			"max":[
				0.8942676782608032,
				1.0296698808670044,
				3.094804048538208
			],
			"min":[
				-0.6190509796142578,
				-1,
				-3.094804048538208
			],
			"type":"VEC3"
		},
		{
			"bufferView":5,
			"componentType":5126,
			"count":112,
			"type":"VEC3"
		},
		{
			"bufferView":6,
			"componentType":5126,
			"count":112,
			"type":"VEC2"
		},
		{
			"bufferView":7,
			"componentType":5123,
			"count":192,
			"type":"SCALAR"
		},
		{
			"bufferView":8,
			"componentType":5126,
			"count":112,
			"max":[
				0.8942676782608032,
				1.0296698808670044,
				3.094804048538208
			],
			"min":[
				-0.6190509796142578,
				-1,
				-3.094804048538208
			],
			"type":"VEC3"
		},
		{
			"bufferView":9,
			"componentType":5126,
			"count":112,
			"type":"VEC3"
		},
		{
			"bufferView":10,
			"componentType":5126,
			"count":112,
			"type":"VEC2"
		},
		{
			"bufferView":11,
			"componentType":5126,
			"count":112,
			"max":[
				0.8942676782608032,
				1.0296698808670044,
				3.094804048538208
			],
			"min":[
				-0.6190509796142578,
				-1,
				-3.094804048538208
			],
			"type":"VEC3"
		},
		{
			"bufferView":12,
			"componentType":5126,
			"count":112,
			"type":"VEC3"
		},
		{
			"bufferView":13,
			"componentType":5126,
			"count":112,
			"type":"VEC2"
		},
		{
			"bufferView":14,
			"componentType":5126,
			"count":24,
			"max":[
				0.12331390380859375,
				0.3768068552017212,
				0.13226842880249023
			],
			"min":[
				-0.12331390380859375,
				-0.3768068552017212,
				-0.13226830959320068
			],
			"type":"VEC3"
		},
		{
			"bufferView":15,
			"componentType":5126,
			"count":24,
			"type":"VEC3"
		},
		{
			"bufferView":16,
			"componentType":5126,
			"count":24,
			"type":"VEC2"
		},
		{
			"bufferView":17,
			"componentType":5123,
			"count":36,
			"type":"SCALAR"
		},
		{
			"bufferView":18,
			"componentType":5126,
			"count":24,
			"max":[
				0.12331390380859375,
				0.3768068552017212,
				0.13226842880249023
			],
			"min":[
				-0.12331390380859375,
				-0.3768068552017212,
				-0.13226830959320068
			],
			"type":"VEC3"
		},
		{
			"bufferView":19,
			"componentType":5126,
			"count":24,
			"type":"VEC3"
		},
		{
			"bufferView":20,
			"componentType":5126,
			"count":24,
			"type":"VEC2"
		},
		{
			"bufferView":21,
			"componentType":5126,
			"count":224,
			"max":[
				0.9102854132652283,
				1.0557153224945068,
				0.9102854132652283
			],
			"min":[
				-0.9102854132652283,
				-0.9018439054489136,
				-0.9102854132652283
			],
			"type":"VEC3"
		},
		{
			"bufferView":22,
			"componentType":5126,
			"count":224,
			"type":"VEC3"
		},
		{
			"bufferView":23,
			"componentType":5126,
			"count":224,
			"type":"VEC2"
		},
		{
			"bufferView":24,
			"componentType":5123,
			"count":324,
			"type":"SCALAR"
		},
		{
			"bufferView":25,
			"componentType":5126,
			"count":30,
			"max":[
				1.3272992372512817,
				0.21638387441635132,
				1
			],
			"min":[
				-2.4162750244140625,
				-1,
				-1.789177417755127
			],
			"type":"VEC3"
		},
		{
			"bufferView":26,
			"componentType":5126,
			"count":30,
			"type":"VEC3"
		},
		{
			"bufferView":27,
			"componentType":5126,
			"count":30,
			"type":"VEC2"
		},
		{
			"bufferView":28,
			"componentType":5123,
			"count":48,
			"type":"SCALAR"
		},
		{
			"bufferView":29,
			"componentType":5126,
			"count":30,
			"max":[
				1.3272992372512817,
				0.21638387441635132,
				1
			],
			"min":[
				-2.4162750244140625,
				-1,
				-1.7891775369644165
			],
			"type":"VEC3"
		},
		{
			"bufferView":30,
			"componentType":5126,
			"count":30,
			"type":"VEC3"
		},
		{
			"bufferView":31,
			"componentType":5126,
			"count":30,
			"type":"VEC2"
		},
		{
			"bufferView":32,
			"componentType":5126,
			"count":72,
			"max":[
				1.3481192588806152,
				0.6197910308837891,
				0.5966057777404785
			],
			"min":[
				-0.8679153919219971,
				-0.9439473152160645,
				-0.5283350944519043
			],
			"type":"VEC3"
		},
		{
			"bufferView":33,
			"componentType":5126,
			"count":72,
			"type":"VEC3"
		},
		{
			"bufferView":34,
			"componentType":5126,
			"count":72,
			"type":"VEC2"
		},
		{
			"bufferView":35,
			"componentType":5123,
			"count":132,
			"type":"SCALAR"
		},
		{
			"bufferView":36,
			"componentType":5126,
			"count":72,
			"max":[
				1.3481193780899048,
				0.44371485710144043,
				0.9865543842315674
			],
			"min":[
				-0.8679153919219971,
				-0.5842263102531433,
				-0.6333475112915039
			],
			"type":"VEC3"
		},
		{
			"bufferView":37,
			"componentType":5126,
			"count":72,
			"type":"VEC3"
		},
		{
			"bufferView":38,
			"componentType":5126,
			"count":72,
			"type":"VEC2"
		},
		{
			"bufferView":39,
			"componentType":5123,
			"count":132,
			"type":"SCALAR"
		},
		{
			"bufferView":40,
			"componentType":5126,
			"count":192,
			"max":[
				1,
				1,
				1
			],
			"min":[
				-1,
				-1,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":41,
			"componentType":5126,
			"count":192,
			"type":"VEC3"
		},
		{
			"bufferView":42,
			"componentType":5126,
			"count":192,
			"type":"VEC2"
		},
		{
			"bufferView":43,
			"componentType":5123,
			"count":372,
			"type":"SCALAR"
		},
		{
			"bufferView":44,
			"componentType":5126,
			"count":192,
			"max":[
				1,
				1,
				1
			],
			"min":[
				-1,
				-1,
				-1
			],
			"type":"VEC3"
		},
		{
			"bufferView":45,
			"componentType":5126,
			"count":192,
			"type":"VEC3"
		},
		{
			"bufferView":46,
			"componentType":5126,
			"count":192,
			"type":"VEC2"
		}
	],
	"bufferViews":[
		{
			"buffer":0,
			"byteLength":4416,
			"byteOffset":0,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":4416,
			"byteOffset":4416,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2944,
			"byteOffset":8832,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1032,
			"byteOffset":11776,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":12808,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":14152,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":896,
			"byteOffset":15496,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":384,
			"byteOffset":16392,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":16776,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":18120,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":896,
			"byteOffset":19464,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":20360,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1344,
			"byteOffset":21704,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":896,
			"byteOffset":23048,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":23944,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":24232,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":192,
			"byteOffset":24520,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":72,
			"byteOffset":24712,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":24784,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":288,
			"byteOffset":25072,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":192,
			"byteOffset":25360,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2688,
			"byteOffset":25552,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2688,
			"byteOffset":28240,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1792,
			"byteOffset":30928,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":648,
			"byteOffset":32720,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":33368,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":33728,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":240,
			"byteOffset":34088,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":96,
			"byteOffset":34328,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":34424,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":360,
			"byteOffset":34784,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":240,
			"byteOffset":35144,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":35384,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":36248,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":576,
			"byteOffset":37112,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":264,
			"byteOffset":37688,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":37952,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":864,
			"byteOffset":38816,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":576,
			"byteOffset":39680,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":264,
			"byteOffset":40256,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":40520,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":42824,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1536,
			"byteOffset":45128,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":744,
			"byteOffset":46664,
			"target":34963
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":47408,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":2304,
			"byteOffset":49712,
			"target":34962
		},
		{
			"buffer":0,
			"byteLength":1536,
			"byteOffset":52016,
			"target":34962
		}
	],
	"buffers":[
		{
			"byteLength":53552,
			"uri":"player_yellow_walk2.bin"
		}
	]
}
